export default __webpack_public_path__ + "static/media/pvilla7-4.243aca29.jpg";